var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projects-feed"},_vm._l((_vm.docs),function(doc,i){return _c('project',{key:doc.id,style:({zIndex: _vm.docs.length - i}),attrs:{"doc":doc,"prjNo":i}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }